module.exports = __webpack_public_path__ + "img/div3s.29e69918.jpg";